module.exports = __webpack_public_path__ + "static/media/gofabric_home.e1fdfa15.png";